// React imports
import React from 'react';

// Context imports
import { useGlobalContext } from '../../context/GlobalStore';
import { useUserContext } from '../../context/UserStore';

// Material-UI imports
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Button, IconButton, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Component imports
import ProfileOptionsMenu from '../Menu/ProfileOptionsMenu';

// Styled AppBar with animated gradient
const AnimatedAppBar = styled(AppBar)(({ theme }) => ({
  background: 'linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab, #f093fb, #f5576c, #4facfe, #00f2fe)',
  backgroundSize: '400% 400%',
  animation: 'gradientShift 15s ease infinite',
  
  '@keyframes gradientShift': {
    '0%': {
      backgroundPosition: '0% 50%'
    },
    '50%': {
      backgroundPosition: '100% 50%'
    },
    '100%': {
      backgroundPosition: '0% 50%'
    }
  },
  
  // Add a subtle overlay for better text readability
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.1)',
    zIndex: 0
  },
  
  // Ensure toolbar content is above the overlay
  '& .MuiToolbar-root': {
    position: 'relative',
    zIndex: 1
  }
}));

/**
 * AppHeader Component
 * Main application header with animated gradient background
 */
export const AppHeader = (props) => {
  // Context hooks for state management
  const { state: globalState, action: globalActions } = useGlobalContext();
  const { state: userState } = useUserContext();
  const { title } = props;
  
  return (
    <AnimatedAppBar position="static">
      <Toolbar>
        {/* Menu Toggle Button */}
        <div onClick={globalActions.toggleSideMenu}>
          <IconButton 
            size="large" 
            edge="start" 
            color="inherit" 
            aria-label="menu" 
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        </div>

        {/* App Title */}
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            flexGrow: 1,
            fontWeight: 'bold',
            textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
          }}
        >
          {title}
        </Typography>
        
        {/* Profile Menu */}
        <ProfileOptionsMenu />
      </Toolbar>
    </AnimatedAppBar>
  );
};
